export default {
  setOutfitsData(state, payload = []) {
    state.outfits = payload
  }
};
